module.exports = __webpack_public_path__ + "static/media/MorningLight.13fb3146.jpg";